<template>
	<c-dialog ref="dialog" width="400" height="300" @resolve="editHandle">
		<c-form ref="form" vertical unit-width="100%">
			<c-input type="hidden" name="id"></c-input>
			<c-form-item label="角色名称" required>
				<c-input name="role_name" maxlength="50"></c-input>
			</c-form-item>
			<c-form-item label="备注">
				<c-input type="textarea" name="remark" maxlength="500"></c-input>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>

export default {
	components: {
	},

	data() {
		return {
		};
	},

	methods: {
		open(data) {
			this._editState = !!data;
			this.$refs.form.clear();
            this.$refs.form.set(data);
            this.$refs.dialog.open();
            //填充form表单
            this.$refs.dialog.open({
                title: this._editState ? '编辑角色' : '新增角色'
            });
        },

		editHandle(stop, next) {
			stop();
			this.$refs.form.submit({
				url: this._editState ? '/system_role/edit' : '/system_role/add',
				rule: {
					role_name: '请输入角色名称'
				},
                dataFormatter: data => {
                    return data;
                },
				success: () => {
					next();
					this.$message({
						message: '提交成功',
						type: 'success'
					});
					this.$emit('resolve');
				}
			});
		}
	}
};
</script>

<style lang="stylus" scoped>
>>> .power {
	border: 1px solid #ddd;
	overflow: auto;
	min-width: 700px;
	max-height: 240px;
	&-list {
		margin-left: 40px;
		overflow: hidden;
	}

	> &-item {
		margin-left: 20px;

		&:nth-last-child(1) {
			margin-bottom: 15px;
		}
	}

	&-item {
		margin-top: 15px;
		margin-right: 20px;
	}
}
</style>
